import { Notify } from "../../helpers/notification";
import apiClient from "../api/apiClient";

export const getWebQueue = (id) => async (dispatch) => {
  try {
    const result = await apiClient.get("/webqueue/" + id);
    return result.data.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateWebQueue = (id, body) => async (dispatch) => {
  try {
    const result = await apiClient.patch("/webqueue/" + id, body);
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
  }
};

export const finishQueue = (id) => async (dispatch) => {
  try {
    const result = await apiClient.post("/webqueue/" + id + "/finish");
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error;
  }
};

export const uploadDocument = (id, slot, file) => async (dispatch) => {
  try {
    const body = new FormData();
    body.append("file", file);
    const result = await apiClient.post(
      "/webqueue/" + id + "/documents/" + encodeURIComponent(slot),
      body,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error;
  }
};


export const uploadSignature = (id, body) => async (dispatch) => {
  try {
    const result = await apiClient.post("/webqueue/" + id + "/signature", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error;
  }
};

// Office (iPad walk-in) application: create the LobbyQueue record on the first
// form save. Returns { zzID } — the id the rest of the onboarding flow keys on.
// (Web applicants already have a record from their inquiry, so they don't call this.)
export const createWebQueue = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("/webqueue", body);
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error;
  }
};



// Office "save and come back later": ask the backend to email the applicant a
// resume link so they can finish the application from home. The form data is
// already saved via updateWebQueue/createWebQueue before this is called.
export const saveAndComeBackLater = (id) => async (dispatch) => {
  try {
    const result = await apiClient.post("/webqueue/" + id + "/save-and-come-back");
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error;
  }
};

export const deleteQueueById = (id, body) => async (dispatch) => {
  try {
    const result = await apiClient.delete("api/webqueue/delete/" + id);
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
  }
};

export const checkIPAction = () => async (dispatch) => {
  try {
    const result = await apiClient.get("api/webqueue/check-ip");
    return result.data.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error
  }
};
